import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
// import {FormattedMessage} from "react-intl";

import {loaderDisable, loaderEnable} from "../../../ui/loaderView";

import {setPresetWasChangedByUser, updateCanvasCount} from "../../../../actions/actionFunctions";
import MaterialSpinner from "../../../ui/materialSpinner";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {applyNewPreset} from "../../lookNavigation/lookNavigationFunctions";

const GroheRoomPreset = (props) => {

  const {roomPreset, updateCanvasCount, activePreset, setPresetWasChangedByUser, loadedPresets} = props;

  const isActive = activePreset && (roomPreset.id === activePreset);

  const roomPresetClick = async () => {

    if (isActive) {
      return false
    }

    loaderEnable();
    setPresetWasChangedByUser(roomPreset.id);
    console.log("roomPreset", roomPreset);

    const analyticsQuery = `id=${roomPreset.id}-lookId=${roomPreset.lookId}-layout_type=${roomPreset.layout_type}-scene=${roomPreset.scene}`;
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productRoomIdeasPreset + analyticsQuery);

    await applyNewPreset(roomPreset, loadedPresets);
    updateCanvasCount();
    loaderDisable();
  }

  return (
    <li className="ll-layout ll-room" onClick={roomPresetClick}>
      <div className="ll-layout__thumbnail" style={{backgroundImage: `url(${roomPreset.bv_screen})`}}>
        {roomPreset.bv_screen ? null : <MaterialSpinner/>}
      </div>
      {roomPreset.presetTitle || roomPreset.presetPrice ? (
        <div className="ll-layout__content">
          <div className="ll-layout__content-title bold">
            {roomPreset.presetTitle
              ? <span className="ll-layout__content-title-name">Style: {roomPreset.presetTitle}</span>
              : null}
            {/*<span className="ll-layout__content-title-name">RoomLayout: {roomPreset.layout_type}</span>*/}
            {/*<span className="ll-layout__content-title-sqm">RoomScene: {roomPreset.scene}</span>*/}
          </div>
          {roomPreset.presetPrice
            ? <div className="ll-layout__content-description">Price: ${roomPreset.presetPrice}</div>
            : null}
        </div>
      ) : null}
    </li>
  )
};

GroheRoomPreset.propTypes = {
  roomPreset: PropTypes.object,
}

const mapStateToProps = (store) => {
  const {activePreset, loadedPresets} = store.bathroomVisualizerState;
  return {
    activePreset,
    loadedPresets,
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
  setPresetWasChangedByUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheRoomPreset)

